import "./Footer.css";

function Footer() {
    return (
        <footer className="footer">
            <p className="footer-name">NikaVeraTattoo</p>
            <div className="footer-links">
                <a href="https://instagram.com/" target="_blank" rel="noreferrer">Instagram</a>
                <a href="mailto:hello@example.com">Email</a>
            </div>
              <p className="footer-copy">2026 / Reykjavik</p>
        </footer>
    );
}
export default Footer;